//  * @package         src/components/Dashboard
//  * @author          Riddhi D Parekh
//  * @date            22nd October 2018
//  * @type            Settings Left Component File
//  * @description -   This file renders the html and functionality that renders at left panel for settings tab.
<template>
  <div class="colume_1_option_elements">
    <div class="tab-content">
      <div class="tab-pane fade in active">
        <div class="colume_1_elements survey_name">
          <h3>form name</h3>
          <div class="elements_sec">
            <textarea
              maxlength="255"
              :value="all.st_survey_name"
              @blur="updateSurvey_name"
              rows="3"
              class="form-control"
              placeholder
            ></textarea>
          </div>
        </div>

        <div class="colume_1_elements survey_type">
          <h3>form type</h3>
          <div class="elements_sec">
            <a
              :value="all.type2"
              v-on:click="all.in_status === vueCommonConfig.SURVEY_PUBLISHED ? sessionData['requestUserType'] === userTypeConfig.TYPE_ACCOUNT_ADMIN && isActive2 === 0 ? toggleType2() : '' : toggleType2()"
              v-bind:class="[isActive2 ? 'activetype elements_sec_box' : 'elements_sec_box',isActive3 ? 'disable_kiosk_control':'']"
            >
              <i class="fa fa-mobile" aria-hidden="true"></i>
              <span
                v-if="surveytypes[1]"
                v-bind:class="[ isActive2 ? 'activetypespan' : '']"
              >{{ surveytypes[1]['st_survey_type'] }}</span>
              <span id="addSettings" v-if="isActive2">
                <i
                  class="fa fa-cog"
                  aria-hidden="true"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Advanced Settings"
                  v-on:click.stop="isActive2 ? renderMobileSettings() : ''"
                ></i>
              </span>
            </a>
            <a
              :value="all.type1"
              v-on:click="all.in_status === vueCommonConfig.SURVEY_PUBLISHED ? sessionData['requestUserType'] === userTypeConfig.TYPE_ACCOUNT_ADMIN ? toggleType1() : '' : toggleType1()"
              v-bind:class="[isActive1 ? 'activetype elements_sec_box' : 'elements_sec_box',isActive3 ? 'disable_kiosk_control':'']"
            >
              <i class="fa fa-globe" aria-hidden="true"></i>
              <span
                v-if="surveytypes[0]"
                v-bind:class="[ isActive1 ? 'activetypespan' : '']"
              >{{ surveytypes[0]['st_survey_type'] }}</span>
              <span id="addSettings" v-if="isActive1">
                <i
                  class="fa fa-cog"
                  aria-hidden="true"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Advanced Settings"
                  v-on:click.stop="isActive1 ? renderOnlineSettings() : ''"
                ></i>
              </span>
            </a>
            <a
              :value="all.type3"
              v-on:click="all.in_status === vueCommonConfig.SURVEY_PUBLISHED ? '' : toggleType3()"
              v-bind:class="[isActive3 ? 'activetype elements_sec_box' : 'elements_sec_box']"
            >
              <i class="fa fa-desktop" aria-hidden="true"></i>
              <span
                v-if="surveytypes[2]"
                v-bind:class="[ isActive3 ? 'activetypespan' : '']"
              >{{ surveytypes[2]['st_survey_type'] }}</span>
            </a>
          </div>
        </div>
        <div class="colume_1_elements survey_question_flow" :class="[isActive3 ? 'disable_kiosk_control':'']">
          <h3>question flow</h3>
          <div class="elements_sec">
            <a
              :value="all.in_question_flow"
              v-on:click="toggleFlow1"
              v-bind:class="[isActiveFlow1 ? 'activetype elements_sec_box' : 'elements_sec_box']"
            >
              <i class="fa fa-long-arrow-down" aria-hidden="true"></i>
              <span v-bind:class="[isActiveFlow1 ? 'activetypespan' : '']">one at a time</span>
            </a>
            <a
              :value="all.in_question_flow"
              v-on:click="toggleFlow2"
              v-bind:class="[isActiveFlow2 ? 'activetype elements_sec_box' : 'elements_sec_box']"
            >
              <i class="fa fa-sort-alpha-asc" aria-hidden="true"></i>
              <span v-bind:class="[isActiveFlow2 ? 'activetypespan' : '']">all in one</span>
            </a>
          </div>
        </div>
        <div
          class="colume_1_elements survey_option"
        >
          <h3>form option</h3>
          <div class="elements_sec">
            <div class="survey_answer_option">
              <label class="switch" :class="[isActive3 ? 'disable_kiosk_control':'']" >
                <input
                  :value="all.in_audit"
                  @change="updateSurvey_audit"
                  :checked="isActive3 ? false : all.in_audit"
                  type="checkbox"
                  :disabled="all.in_status ===  vueCommonConfig.SURVEY_PUBLISHED ? true : false"
                >
                <span class="slider round"></span>
              </label>
              <p>audit</p>
            </div>
            <div class="survey_answer_option">
              <label class="switch" :class="[isActive3 ? 'disable_kiosk_control':'']">
                <input
                  :value="all.in_loop_survey"
                  @change="updateSurvey_loop"
                  type="checkbox"
                  :checked="isActive3 ? true : all.in_loop_survey"
                >
                <span class="slider round"></span>
              </label>
              <p>loop form</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="myModalRef" title="Mobile Form Settings" id="surveySettingModal" hide-footer>
      <div slot="modal-title" v-if="modalOrOnline === 0">Mobile Form Settings</div>
      <div slot="modal-title" v-else>Online Form Settings</div>
      <div slot="modal-header-close">
        <button type="button" class="close" @click="closeModal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="form-group row survey_settings">
        <div class="col-md-6">
          <h6 class="edit_head">Responses</h6>
          <div class="align-text">
            <div class="answer_btn">
              <label class="switch">
                <input
                  v-model="surveySettingsData.in_response_setting"
                  value="0"
                  name="response_value"
                  type="radio"
                >
                <span class="slider round"></span>
              </label>
            </div>

            <span>Allow one response</span>
          </div>
          <div class="align-text">
            <div class="answer_btn">
              <label class="switch">
                <input
                  v-model="surveySettingsData.in_response_setting"
                  value="1"
                  name="response_value"
                  type="radio"
                >
                <span class="slider round"></span>
              </label>
            </div>
            <span>Allow multiple response</span>
          </div>
        </div>
        <div class="col-md-6" v-if="modalOrOnline === 0"></div>
        <div class="col-md-6" v-else>
          <h6 class="edit_head">Access</h6>
          <div class="align-text">
            <div class="answer_btn">
              <label class="switch">
                <input
                  type="checkbox"
                  name="access"
                  v-model="surveySettingsData.in_access_setting_int"
                  v-validate="surveySettingsData.in_access_setting_ext != 1 ? 'required':''"
                >
                <span class="slider round"></span>
              </label>
            </div>
            <span>Allow internal access</span>
          </div>
          <div class="align-text">
            <div class="answer_btn">
              <label class="switch">
                <input
                  type="checkbox"
                  v-model="surveySettingsData.in_access_setting_ext"
                  name="access"
                  v-validate="surveySettingsData.in_access_setting_int != 1 ? 'required':''"
                >
                <span class="slider round"></span>
              </label>
            </div>
            <span>Allow external access</span>
          </div>
          <span class="error" v-if="errors.has('access')">{{ errors.first('access') }}</span>
        </div>
      </div>
      <div class="row survey_settings">
        <div class="col-md-6">
          <div class="end_save_btn save_reset">
            <a class="btn-reset"
              href="#"
              @click.prevent="modalOrOnline === 0 ? resetSettings() : resetOnlineSettings()"
            >
              <span>reset</span>
            </a>
          </div>
        </div>
        <div class="col-md-6">
          <div class="end_save_btn save_cancel paddingB0">
            <a class="btn-cancel" href="#" @click.prevent="closeModal">Cancel</a>
            <a class="btn-whitelable"
              href="#"
              @click.prevent="modalOrOnline === 0 ? saveSettings() : saveOnlineSettings()"
            >
              <span>Save</span>
            </a>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { EventBus } from "../../main";
import { mapGetters, mapActions } from "vuex";
var { constantCommonConfig } = require("../../../config/config.js");
var { userTypeConfig } = require("../../../config/config.js");

export default {
  name: "settingleft",
  // props:['initialData'],
  data() {
    return {
      isActive1: 0,
      isActive2: 0,
      isActive3: 0,
      isActiveFlow1: 0,
      isActiveFlow2: 0,
      sessionData: [],
      surveySettingsData: {},
      modalOrOnline: -1,
      vueCommonConfig: constantCommonConfig,
      userTypeConfig : userTypeConfig
    };
  },
  computed: {
    ...mapGetters("LeftSidebarCreate", ["all", "surveytypes"]),
    ...mapGetters("editquestion", ["surveySettings"])
  },
  created() {
    this.sessionData = this.$session.getAll();
    this.sessionData["in_survey_Id"] = this.$route.params.id;

    if (this.all) {
      this.isActive1 = this.all.type1;
      this.isActive2 = this.all.type2;
      this.isActive3 = this.all.type3;
      if (this.all.in_question_flow == 0) {
        this.isActiveFlow1 = 1;
      } else {
        this.isActiveFlow2 = 1;
      }
    }
  },
  methods: {
    ...mapActions("LeftSidebarCreate", [
      "actiontoggleType1",
      "actiontoggleType2",
      "actiontoggleType3",
      "actiontoggleFlow0",
      "actiontoggleFlow1",
      "setSurvey_name",
      "setSurvey_audit",
      "setSurvey_loop"
    ]),
    ...mapActions("editquestion", ["setSurveySettings", "getSurveySettings"]),

    toggleType1() {
      if (!(this.all.type1 == 1 && this.all.type2 == 0)) {
        this.actiontoggleType1(this.sessionData);
        this.isActive1 = this.all.type1;
        this.isActive3 = false;
      }
    },
    toggleType2() {
      if (!(this.all.type1 == 0 && this.all.type2 == 1)) {
        this.actiontoggleType2(this.sessionData);
        this.isActive2 = this.all.type2;
        this.isActive3 = false;
      }
    },
    toggleType3() {
        this.actiontoggleType3(this.sessionData);
        this.isActive3 = this.all.type3;
        this.isActive2 = false;
        this.isActive1 = false;
        this.isActiveFlow1 = true;
        this.isActiveFlow2 = false;
        if(this.isActive3 == true && this.all.in_audit == true){
          this.updateSurvey_audit(this.sessionData);
        }
        if(this.isActive3 == true && this.all.in_loop_survey == false){
          this.updateSurvey_loop(this.sessionData);
        }
        if(this.isActive3 != true){
          this.isActive2 = true;
          this.isActiveFlow1 = false;
          this.isActiveFlow2 = true;
          this.toggleFlow2();
        }
    },
    toggleFlow1() {
      this.isActiveFlow1 = 1;
      this.isActiveFlow2 = 0;
      this.actiontoggleFlow0(this.sessionData);
    },
    toggleFlow2() {
      this.isActiveFlow2 = 1;
      this.isActiveFlow1 = 0;
      this.actiontoggleFlow1(this.sessionData);
    },
    toggleFlow3(){
      this.isActiveFlow1 = 0;
      this.isActiveFlow2 = 0;
      this.actiontoggleFlow2(this.sessionData);
    },
    updateSurvey_name(e) {
      e.target.value = e.target.value.trim();
      if (
        e.target.value &&
        e.target.value.length >= 6 &&
        e.target.value.length <= 255
      ) {
        this.setSurvey_name([e.target.value, this.sessionData]);
      } else {
        e.target.value = this.all.st_survey_name;
        this.$awn.alert(
          "Form Name should have atleast 6 characters & atmost 255 characters"
        );
      }
    },
    updateSurvey_audit(e) {
      this.setSurvey_audit(this.sessionData);
    },
    updateSurvey_loop(e) {
      this.setSurvey_loop(this.sessionData);
    },
    async renderMobileSettings() {
      this.modalOrOnline = 0;
      this.sessionData.in_survey_type_id = this.all.in_survey_type;
      await this.getSurveySettings(this.sessionData).then(() => {
        this.surveySettings.forEach((value, key) => {
          if (value["in_survey_type_id"] == 2) {
            this.surveySettingsData = Object.assign({}, value);
            document.body.appendChild(this.$refs.myModalRef.$el);
            this.$refs.myModalRef.show();
          }
        });
      });
    },
    async renderOnlineSettings() {
      this.modalOrOnline = 1;
      this.sessionData.in_survey_type_id = this.all.in_survey_type;
      await this.getSurveySettings(this.sessionData).then(() => {
        this.surveySettings.forEach((value, key) => {
          if (value["in_survey_type_id"] == 1) {
            this.surveySettingsData = Object.assign({}, value);
            document.body.appendChild(this.$refs.myModalRef.$el);
            this.$refs.myModalRef.show();
          }
        });
      });
    },
    saveSettings() {
      this.sessionData.in_survey_type_id = 2;
      this.sessionData.in_response_setting = this.surveySettingsData.in_response_setting;
      this.setSurveySettings(this.sessionData);
      this.closeModal();
    },
    async resetSettings() {
      this.sessionData.in_survey_type_id = 2;
      this.sessionData.in_response_setting = 1;
      await this.setSurveySettings(this.sessionData).then(() => {
        this.surveySettingsData = Object.assign({}, this.surveySettings[0]);
        this.closeModal();
      });
    },
    closeModal() {
      this.$refs.myModalRef.hide();
      this.errors.clear();
    },
    saveOnlineSettings() {
      this.$validator.validateAll({ in_access_setting: true }).then(() => {
        if (this.errors.items.length === 0) {
          this.sessionData.in_survey_type_id = 1;
          this.sessionData.in_response_setting = this.surveySettingsData.in_response_setting;
          this.surveySettingsData.in_access_setting_int == 1
            ? this.surveySettingsData.in_access_setting_ext == 1
              ? (this.sessionData.in_access_setting = 3)
              : (this.sessionData.in_access_setting = 1)
            : this.surveySettingsData.in_access_setting_ext == 1
            ? (this.sessionData.in_access_setting = 2)
            : "";
          this.setSurveySettings(this.sessionData);
          this.closeModal();
        }
      });
    },
    async resetOnlineSettings() {
      this.sessionData.in_survey_type_id = 1;
      this.sessionData.in_response_setting = 0;
      this.sessionData.in_access_setting = 3;
      console.log(this.sessionData);
      await this.setSurveySettings(this.sessionData).then(() => {
        console.log("jjj");
        console.log(this.surveySettings);
        this.surveySettingsData = Object.assign({}, this.surveySettings[0]);
        this.closeModal();
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/settingleft.vue